import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { publicAPI } from './api'
import { appReducer, aiAssistantReducer } from './slices'

const rootReducer = combineReducers({
  [publicAPI.reducerPath]: publicAPI.reducer,
  aiAssistantState: aiAssistantReducer,
  appState: appReducer,
})

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['aiAssistantState'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV === 'development',

  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([publicAPI.middleware]),
})

export const persistor = persistStore(store)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
